/* Treatment timeline: pins the whole stage (banner + card) while the section's
   scroll runway passes; step cards deck-stack in place, scrubbing both
   directions. Crossfades banner images. No-ops under reduced motion or below
   744px — the static expanded list in the DOM is the fallback rendering. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__ttInit) return;
    root.__ttInit = true;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.innerWidth < 744;
    if (reduced || mobile) return; // static list, no pin, no crossfade

    root.classList.add('tt--enhanced');

    var stage = root.querySelector('.tt__stage');
    var list = root.querySelector('.tt__steps');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.tt__step'));
    var N = steps.length;
    if (!stage || !N) return;

    // Deck geometry + expanded-list geometry
    var GAP = 12;
    var PEEK = 22;
    var heights = steps.map(function (s) { return s.offsetHeight; });
    var maxH = Math.max.apply(null, heights);
    var deckH = maxH + (N - 1) * PEEK;
    var cumY = [0];
    for (var i = 1; i < N; i++) cumY[i] = cumY[i - 1] + heights[i - 1] + GAP;
    var fullH = cumY[N - 1] + heights[N - 1];
    list.style.height = deckH + 'px';

    // Scroll runway: stacking phase + expansion phase
    var runway = Math.round(window.innerHeight * (0.35 + N * 0.5 + 0.55));
    root.style.height = stage.offsetHeight + runway + 'px';
    var EXPAND_START = 0.76;

    var ticking = false;
    function apply() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, -rect.top / runway));
      root.classList.toggle('tt--done', p >= EXPAND_START + (1 - EXPAND_START) * 0.5);
      if (p < EXPAND_START) {
        var active = Math.min(N - 1, Math.floor((p / EXPAND_START) * (N + 0.35)));
        list.style.height = deckH + 'px';
        steps.forEach(function (s, i) {
          var settled = i <= active;
          var behind = i < active;
          s.classList.toggle('is-in', settled);
          s.classList.toggle('is-behind', behind);
          if (settled) {
            s.style.opacity = behind ? String(Math.max(0.55, 1 - (active - i) * 0.18)) : '1';
            s.style.transform = 'translateY(' + i * PEEK + 'px)' + (behind ? ' scale(0.975)' : '');
          } else {
            s.style.opacity = '';
            s.style.transform = '';
          }
        });
      } else {
        // Finale: deck expands out into the full list
        var q = (p - EXPAND_START) / (1 - EXPAND_START);
        q = q * q * (3 - 2 * q);
        list.style.height = Math.round(deckH + (fullH - deckH) * q) + 'px';
        steps.forEach(function (s, i) {
          s.classList.add('is-in');
          s.classList.remove('is-behind');
          var y = i * PEEK + (cumY[i] - i * PEEK) * q;
          var sc = 0.975 + 0.025 * q;
          s.style.opacity = String(Math.min(1, 0.7 + 0.3 * q + (i === N - 1 ? 0.3 : 0)));
          s.style.transform = 'translateY(' + y + 'px)' + (i < N - 1 ? ' scale(' + sc + ')' : '');
        });
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    root.__ttScroll = onScroll;
    apply();

    var imgs = root.querySelectorAll('.tt__banner img');
    if (imgs.length > 1) {
      var current = 0;
      root.__ttTimer = window.setInterval(function () {
        imgs[current].classList.remove('is-active');
        current = (current + 1) % imgs.length;
        imgs[current].classList.add('is-active');
      }, 4500);
    }
  }

  function destroy(root) {
    if (!root) return;
    if (root.__ttScroll) window.removeEventListener('scroll', root.__ttScroll);
    if (root.__ttTimer) window.clearInterval(root.__ttTimer);
    root.__ttInit = false;
    root.classList.remove('tt--enhanced');
    root.style.height = '';
  }

  function boot() {
    document.querySelectorAll('[data-treatment-timeline]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-treatment-timeline]');
    if (root) init(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-treatment-timeline]');
    if (root) destroy(root);
  });
})();
